import '@fontsource/roboto/latin-400.css'
import '@fontsource/roboto/latin-500.css'
import '@fontsource/roboto/latin-700.css'
import '@fontsource/poppins/latin-500.css'
import '@fontsource/poppins/latin-600.css'
import '@fontsource/roboto-mono/latin-400.css'
import '@fontsource/roboto-mono/latin-500.css'
import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { ThemeProvider } from '@/components/generals/theme-provider'
import { TooltipProvider } from '@/components/ui/tooltip'
import { ToastProvider } from '@/components/ui/toast'

// GoodUnited typography: Roboto for interface text, Poppins for headings and key metrics, Roboto Mono for code.
// The faces ship with the project (@fontsource, imported above), so the publish build never has to fetch them.
const fontVariables = ":root{--font-app-sans:'Roboto',ui-sans-serif,system-ui,sans-serif;--font-app-mono:'Roboto Mono',ui-monospace,SFMono-Regular,Menlo,monospace;--font-app-heading:'Poppins',ui-sans-serif,system-ui,sans-serif}"

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <ThemeProvider>
                <TooltipProvider delay={200}>
                    <ToastProvider>
                        <Component {...pageProps} />
                    </ToastProvider>
                </TooltipProvider>
            </ThemeProvider>
        </div>
    )
}

export default App
